import React, { Component } from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './CustomLoginLogo.scss';

export default class CustomLoginLogo extends Component {
    static displayName = displayName('Login/CustomLoginLogo');

    static propTypes = {
        children: PropTypes.node.isRequired,
        src: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = { customImageLoadError: false };
    }

    handleCustomImageError = () => {
        this.setState({ customImageLoadError: true });
    };

    render() {
        const { children, ...imageProps } = this.props;

        if (this.state.customImageLoadError) {
            return (<data data-custom-logo-src={imageProps.src}>
                {children}
            </data>);
        }

        return (
            <img
                alt=""
                className={styles['custom-logo']}
                onError={this.handleCustomImageError}
                data-custom-logo-src={imageProps.src}
                {...imageProps}
            />
        );
    }
}
